export const matchesPropertyInsensitive = (propName, string) => el => el[propName].toLowerCase() === string.toLowerCase();
